module.exports = __webpack_public_path__ + "img/bot_intent_shibie.cc33985c.svg";